
export default {
  productData: {
    serialNumber: 'DA-MME-012',
    name: 'Massivholzdecke mit Estrich l Aufbau 12',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolldämmplatte MW<br>(<i>s‘</i> ≤ 8 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 30',
          value: 'm-30'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 109,4 kg/m<sup>2</sup>)' },
          output: '≥ 65',
          value: 'scsb-65'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Brettsperrholzdecke' },
          output: 120,
          value: 'bsh-120'
        }
      ],
      sum: {
        output: '275', value: 275
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '48 (-2; 5)',
        value: 48
      },
      soundReductionIndex: { // Rw
        output: '73 (-1; -6)',
        value: 73
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,44',
        value: 0.44
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '319 [kg/m²]'
      }
    }
  },
  image: 'da-mme-012.svg',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-12-DA-MME-012-Rev01.pdf'
}
